"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageBox = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
exports.AverageBox = react_1.default.memo(({ title, renderItem, isHome = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(AverageBoxStyled, { key: title, "$isMobile": isMobile, "$isDesktop": isDesktop, "$isTablet": isTablet, "$isHome": isHome, className: `average-container ${isHome ? 'home' : ''}` },
        react_1.default.createElement("div", { className: "dst001_detail_title" },
            t(title),
            " "),
        renderItem));
});
const AverageBoxStyled = styled_components_1.default.div `
	${props => props.$isMobile
    ? (0, styled_components_1.css) `
					&.average-container {
						display: flex;
						flex-direction: column;
						gap: 12px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}
					.box-wrap {
						background: var(--color-silver, #f3f4f8);
						border-radius: 10px;
						padding: ${props.$isHome ? '0px' : '12px 10px 12px 10px'};
						display: flex;
						flex-direction: column;
						gap: 12px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						width: 100%;
						display: flex;
					}
					.box-wrap-item {
						width: 100%;
						background: var(--color-white, #ffffff);
						border-radius: 8px;
						padding: ${props.$isHome ? '10px 18px 10px 18px' : '12px 20px 12px 20px'};
						display: flex;
						flex-direction: row;
						gap: ${props.$isHome ? '0px' : '6px'};
						align-items: flex-start;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						min-height: 50px;
					}
			  `
    : (0, styled_components_1.css) `
					&.average-container {
						display: flex;
						flex-direction: column;
						gap: 12px;
						align-items: center;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
					}
					.box-wrap {
						background: var(--color-silver, #f3f4f8);
						border-radius: 10px;
						padding: 12px 10px 12px 10px;
						display: flex;
						flex-direction: column;
						gap: 12px;
						align-items: flex-start;
						justify-content: flex-start;
						flex-shrink: 0;
						position: relative;
						min-width: 200px;
						height: 90%;
					}
					.box-wrap-item {
						flex: 1;
						width: 100%;
						background: var(--color-white, #ffffff);
						border-radius: 8px;
						padding: 10px 18px 10px 18px;
						display: flex;
						flex-direction: column;
						gap: 4px;
						align-items: flex-start;
						justify-content: center;
						flex-shrink: 0;
						position: relative;
					}
			  `}
`;
